/**
 * @generated SignedSource<<4e251cff4a6a3335c5bfe58f6df4579c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pianoIntegrationArticle$data = {
  readonly __typename: "Article";
  readonly authors: ReadonlyArray<{
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly contentLock: boolean | null | undefined;
  readonly createdDate: number | null | undefined;
  readonly entityId: string;
  readonly entityUuid: string;
  readonly flag: string | null | undefined;
  readonly headline: string | null | undefined;
  readonly publishedDate: number | null | undefined;
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
      readonly entityUuid?: string;
      readonly name?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly sponsor: string | null | undefined;
  readonly sponsorType: string | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarVariantBase" | "helpersCheckCanShowInPlusPlatformContent" | "helpersCheckIsPlusArticle" | "helpersIsArchiveWallArticle" | "helpersIsVelocityWallArticle" | "hooksPaywallPromiseContent" | "paywallsGetArticlePaywallTagArticle" | "shareContentUnlockedArticle">;
  readonly " $fragmentType": "pianoIntegrationArticle";
};
export type pianoIntegrationArticle$key = {
  readonly " $data"?: pianoIntegrationArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"pianoIntegrationArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentLock",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = [
  (v3/*: any*/),
  (v9/*: any*/)
],
v11 = [
  (v3/*: any*/)
],
v12 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegmentV2",
    "kind": "LinkedField",
    "name": "sectionsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "VideoSection",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v14 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "fullSectionPath",
        "plural": true,
        "selections": (v11/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Section",
    "abstractKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersIsVelocityWallArticle",
  "selections": (v16/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v18 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersIsArchiveWallArticle",
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/),
    (v15/*: any*/),
    (v17/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v19 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaywallType",
        "kind": "LinkedField",
        "name": "paywallTypes",
        "plural": true,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Article",
    "abstractKey": null
  }
],
v20 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersCheckIsPlusArticle",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v19/*: any*/),
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v21 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersCheckIsPlusArticle",
  "selections": (v19/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v22 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ArticleTypeSegment",
        "kind": "LinkedField",
        "name": "types",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleType",
            "kind": "LinkedField",
            "name": "value",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Article",
    "abstractKey": null
  }
],
v23 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersGetArticleTypeArticle",
  "selections": (v22/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": (v11/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "pianoIntegrationArticle",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsor",
      "storageKey": null
    },
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v9/*: any*/)
              ],
              "type": "Section",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": (v10/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v10/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersAppBarVariantBase",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIsLiveArticle",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "flattenTypeIds",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LiveArticle",
                      "kind": "LinkedField",
                      "name": "liveArticle",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "status",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIsPlusPage",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v7/*: any*/)
                  ],
                  "type": "Page",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIsPostMagazineArticle",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SectionSegmentV2",
                      "kind": "LinkedField",
                      "name": "sectionsV2",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "value",
                          "plural": true,
                          "selections": [
                            (v12/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "Content",
                  "abstractKey": "__isContent"
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIsStyleArticle",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": (v13/*: any*/),
                  "type": "Content",
                  "abstractKey": "__isContent"
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersSectionContent",
              "selections": (v14/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersStyleSectionContent",
              "selections": (v14/*: any*/),
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksPaywallPromiseContent"
    },
    (v18/*: any*/),
    (v17/*: any*/),
    (v20/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckCanShowInPlusPlatformContent",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckArticleIsInSectionsArticle",
              "selections": (v13/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            (v21/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIsStyleArticle",
              "selections": (v13/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            (v23/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersUseContentSponsorContent",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Topic",
                  "kind": "LinkedField",
                  "name": "topics",
                  "plural": true,
                  "selections": [
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sponsor",
                      "kind": "LinkedField",
                      "name": "sponsor",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "sponsorTagSponsor"
                        },
                        (v9/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/)
                  ],
                  "type": "Article",
                  "abstractKey": null
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "helpersCheckIsMainTopicContent",
                  "selections": [
                    (v24/*: any*/)
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "shareContentUnlockedArticle",
      "selections": (v11/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "paywallsGetArticlePaywallTagArticle",
      "selections": [
        (v8/*: any*/),
        (v24/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersGetArticleTypeArticle",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v22/*: any*/),
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        (v20/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersIsSignInWallArticle",
          "selections": (v16/*: any*/),
          "args": null,
          "argumentDefinitions": []
        },
        (v18/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersIsPlusInlinePaywall",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                (v23/*: any*/),
                (v21/*: any*/)
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersIsLiteWallArticle",
          "selections": [
            (v2/*: any*/),
            (v5/*: any*/)
          ],
          "args": null,
          "argumentDefinitions": []
        },
        (v17/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "1a8fed22fcb5a2a1eceea6a1758955c3";

export default node;
